import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { SharedService } from '@AppRoot/shared/services/shared.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  @Output() modalClose = new EventEmitter<void>();
  @Output() feedbackSubmitted = new EventEmitter<any>();
  isLoggedIn = false;

  feedbackForm: FormGroup = new FormGroup({
    rating: new FormControl('', Validators.required),
    title: new FormControl('', [Validators.required, Validators.minLength(5)]),
    description: new FormControl('', [
      Validators.required,
      Validators.minLength(10),
    ]),
  });

  ngOnInit() {
    this._globalutilityService
    .getLoginStatus()
    .subscribe((status) => {
      this.isLoggedIn = status;
    });
  }

  constructor(
    private _globalutilityService: GlobalUtilityService,
    private _sharedService: SharedService
  ) {}

  closeModal() {
    console.log('closeModal');
    this.modalClose.emit(); // Notify parent to hide modal
  }

  submitFeedback() {
    if (this.feedbackForm.valid && this.feedbackForm.dirty) {
      this._sharedService.updateFeedback(this.feedbackForm.value).subscribe({
        next: (res) => {
          this._globalutilityService.showToast(
            'success',
            'Feedback submitted successfully'
          );
          this.closeModal(); // Close modal after submission
        },
        error: (err) => {
          this._globalutilityService.showToast('error', err.error.message);
          this.closeModal(); // Close modal after submission
        },
      });
    }else{
      this._globalutilityService.showToast('error', 'Please fill all the fields correctly');
    }
  }
}
